const UiLoadingPropsOption = {
  message: { type: String, default: "\u52A0\u8F7D\u4E2D" },
  visible: { type: Boolean, default: false },
  zIndex: { type: Number },
  mode: { type: String, default: "absolute" },
  icon: { type: String, default: "loading" }
};

export { UiLoadingPropsOption };
//# sourceMappingURL=loading.mjs.map
